module.exports = __webpack_public_path__ + "static/media/menu.e524e0eb.svg";